module.exports = __webpack_public_path__ + "static/media/uTurnLeft.eb54ead1.svg";